"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOffSite = exports.isInPopup = exports.isInIframe = exports.isBrowser = void 0;
exports.isBrowser = function () { return typeof window !== 'undefined'; };
exports.isInIframe = function () {
    if (!exports.isBrowser())
        return false;
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
exports.isInPopup = function () {
    return exports.isBrowser() && !!window.opener;
};
exports.isOffSite = function () { return exports.isInIframe() || exports.isInPopup(); };
